import React from 'react';
import Section from '../Layout/Section/Section';
import InnerContainer from '../Layout/InnerContainer/InnerContainer';
import Star from '../../components/Dividers/star'
import Wave2 from '../Dividers/Wave2'

import './press-quotes.scss';

const position = [
  '--',
  'top',
  'right',
  'bottom',
  'left',
  'right',
  'bottom',
  'left',
  '--',
]

function renderPressQuotes(quotes) {
  const pressQuotes = [];
  quotes.forEach((quote, i) => {
    i++
    pressQuotes.push(
      <div key={i} id={i} className={`press-quote ${quote.quote.length > 125 ? 'wide' : ''} press-quote--${i}` }>
        <p className="press-quote__body"><q>{quote.quote}</q></p>
        <p className="press-quote__source">{quote.source}</p>
        <Star customClass={`star--${position[i]}`}/>
      </div>
    )
  })
  return pressQuotes;
}

const PressQuotes = ({quotes}) => {
  return (
    <Section>
      <InnerContainer customClass="press-quotes-container">
        {renderPressQuotes(quotes)}
        <Wave2/>
      </InnerContainer>
    </Section>
  )
}

export default PressQuotes
